import request from '@host-panel/request';
import { TModerationUser } from '../state/types';

type RequestPayload = {
  type: TModerationUser;
  count?: number;
  offset?: number;
};

type Response = {
  total: number;
  users: Record<string, any>;
};

export default function fetchModerationUsers({
  count,
  offset,
  type
}: RequestPayload): Promise<Response> {
  return request(`/host-panel/get-allowed-blocked`, {
    method: 'GET',
    data: {
      count,
      offset,
      type
    }
  });
}
